import { defaultInitialState } from '../utils';
import { UPDATE_ACCOUNT_DETAILS, UPDATE_ACCOUNT_DETAILS_DONE, UPDATE_ACCOUNT_DETAILS_ERROR, UPDATE_ACCOUNT_DETAILS_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ACCOUNT_DETAILS:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case UPDATE_ACCOUNT_DETAILS_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case UPDATE_ACCOUNT_DETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case UPDATE_ACCOUNT_DETAILS_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map